// import type { NewsletterHeader } from "../hooks/useHeadersQuery"
import type { Header } from "@features/headers"
import { create } from "zustand"
import type { Offer } from "../../offersList/offersListTypes"

export type NewsletterState = {
  selected: Offer[]
  header: Header | null
  headerUrl: string | null
  isSelected: (offer: Offer) => boolean
  add: (offer: Offer) => void
  remove: (offer: Offer) => void
  toggle: (offer: Offer) => void
  clear: () => void
  updateSelected: (offerId: string, data: Partial<Offer>) => void
  reorderSelected: (fromIndex: number, toIndex: number) => void
  setHeader: (header: Header | null) => void
  setHeaderUrl: (url: string | null) => void
}

export const useNewsletterStore = create<NewsletterState>((set, get) => ({
  selected: [],
  header: null,
  headerUrl: null,
  isSelected: (offer) =>
    get().selected.some((o) => o.CustomOfferID === offer.CustomOfferID),
  add: (offer) =>
    set((state) =>
      state.selected.some((o) => o.CustomOfferID === offer.CustomOfferID)
        ? state
        : { selected: [...state.selected, offer] },
    ),
  remove: (offer) =>
    set((state) => ({
      selected: state.selected.filter(
        (o) => o.CustomOfferID !== offer.CustomOfferID,
      ),
    })),
  toggle: (offer) =>
    set((state) => {
      const exists = state.selected.some(
        (o) => o.CustomOfferID === offer.CustomOfferID,
      )
      return exists
        ? {
            selected: state.selected.filter(
              (o) => o.CustomOfferID !== offer.CustomOfferID,
            ),
          }
        : { selected: [...state.selected, offer] }
    }),
  clear: () => set({ selected: [] }),
  updateSelected: (offerId, data) =>
    set((state) => ({
      selected: state.selected.map((o) =>
        o.CustomOfferID === offerId ? ({ ...o, ...data } as Offer) : o,
      ),
    })),
  reorderSelected: (fromIndex, toIndex) =>
    set((state) => {
      if (
        fromIndex === toIndex ||
        fromIndex < 0 ||
        toIndex < 0 ||
        fromIndex >= state.selected.length ||
        toIndex >= state.selected.length
      ) {
        return state
      }
      const next = state.selected.slice()
      const [moved] = next.splice(fromIndex, 1)
      next.splice(toIndex, 0, moved)
      return { selected: next }
    }),
  setHeader: (header) => set({ header }),
  setHeaderUrl: (url) => set({ headerUrl: url }),
}))
